import React, { useEffect, useState } from 'react'

import HospitalRoom from 'assets/gltfs/HospitalRoom2'
import GenericPopup from 'components/Generic/GenericPopup'
import LookHowPopup from 'components/LookHowPopup'
import ControlWrapper from '../Controls/ControlWrapper'
import CanvasWrapper from '../CanvasWrapper'
import MoveView from '../MoveView'
import { useAppStore } from '../../store/AppStore'
import { useGLTF } from '@react-three/drei'

export default function HospitalRoomScene () {
  useGLTF.preload('gltfs/hospRoom2_GLTF/processed/hospRoom2.gltf')

  const [userInteracted, setUserInteracted] = useState<boolean>(false)
  const [roomAnimationState, setRoomAnimationState] = useState<number>(0)
  const [animatingRoom, setAnimatingRoom] = useState<boolean>(false)

  const [canMove, setCanMove] = useState<boolean>(false)
  const [canDragPan, setCanDragPan] = useState<boolean>(false)

  const [visiblePopup, showPopup] = useState<string | null>('broken_leg')

  const [showMoveView, setShowMoveView] = useState<boolean>(false)
  const [moveCount, setMoveCount] = useState<number>(-1)

  const roomVisible = useAppStore(state => state.roomVisible)

  useEffect(() => {
    if (!animatingRoom && userInteracted) {
      if (!canMove) {
        setCanMove(true)
      } else {
        setRoomAnimationState(roomAnimationState >= 4 ? 1 : roomAnimationState + 1)
      }
    }

    setUserInteracted(false)
  }, [userInteracted])

  const delayShowPopup = (popupName: string, time?: number) => {
    setTimeout(() => {
      showPopup(popupName)
    }, time ?? 750)
  }

  const RenderPopups = () => {
    if (visiblePopup === 'broken_leg') {
      return (
        <GenericPopup title='Broken leg mystery'
                      description='Matt broke his leg. Help find out why. Collect the hazards to solve the mystery.'
                      buttonText="Let's Go"
                      popupImage='/images/Broken_leg.svg'
                      callback={() => {
                        setUserInteracted(true)
                        showPopup(null)
                      }} />
      )
    }

    if (visiblePopup === 'good_luck') {
      return (
        <GenericPopup title='Good Luck!'
                      description='No Hazards to find here yet. But you can look and walk around in this room'
                      buttonText="Tap to continue"
                      popupImage='/images/Detective.svg'
                      callback={() => {
                        showPopup(null)
                      }} />
      )
    }

    if (visiblePopup === 'well_done') {
      return (<GenericPopup title='Well Done!'
                            description='You have completed this level.'
                            buttonText='Replay'
                            popupImage='/images/Shield_complete.svg'
                            extraButtons={[{
                              text: 'exit',
                              callback: () => {
                                window.location.href = '/'
                              }
                            }]}
                            callback={() => {
                              showPopup(null)
                            }} />
      )
    }

    return null
  }

  return (
    <div className={'w-full h-body relative'}>
      <CanvasWrapper>
        <ControlWrapper>
          <HospitalRoom animationState={roomAnimationState}
                        startedMoveAnimationCallback={(animationNumber) => {
                          setAnimatingRoom(true)
                          if (animationNumber === 0 || animationNumber === 4) {
                            delayShowPopup('good_luck')
                          }
                          if (animationNumber === 4) {
                            delayShowPopup('well_done')
                          }
                        }}
                        finishedMoveAnimationCallback={(finishedClipNumber: number) => {
                          setMoveCount(finishedClipNumber === 4 ? 0 : finishedClipNumber)

                          if (animatingRoom) setAnimatingRoom(false)
                          if (!canDragPan && finishedClipNumber === 0) {
                            setCanDragPan(true)
                          }
                          if (finishedClipNumber === 0) setShowMoveView(true)
                        }}
                        canPlay={canMove} />
        </ControlWrapper>
      </CanvasWrapper>

      {roomVisible && <RenderPopups />}
      {showMoveView && !visiblePopup && <MoveView totalCount={3}
                                                  currentCount={moveCount}
                                                  callback={() => {
                                                    setUserInteracted(true)
                                                  }} />}
      {(moveCount === 0 && !visiblePopup) && <LookHowPopup />}
    </div>
  )
}
